module.exports = __webpack_public_path__ + "static/media/vardisgroup.46768923.png";